var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "how-it-works",
        { "how-it-works--on-white": _vm.onWhite },
        "how-it-works--type-" + _vm.type
      ]
    },
    [
      _c(
        "div",
        { staticClass: "how-it-works--items" },
        _vm._l(_vm.howItWorksItems, function(item, i) {
          return _c(
            "div",
            {
              class: {
                "how-it-works--item": true,
                "how-it-works--item-non-free": item.free === false
              }
            },
            [
              _c("div", { staticClass: "how-it-works--item-number" }, [
                _c("span", [_vm._v(_vm._s(i + 1))])
              ]),
              _vm._v(" "),
              item.free !== undefined
                ? _c("div", { staticClass: "how-it-works--item-free-info" }, [
                    _c("span", [
                      _vm._v(_vm._s(item.free ? "Gratis" : "Faire Preise"))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "how-it-works--item-text" }, [
                _vm._v(_vm._s(item.text))
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "how-it-works--item-items" },
                _vm._l(item.items, function(listItem, j) {
                  return _c(
                    "li",
                    { key: "list-item-" + i + "-" + j },
                    [
                      _c("Icon", { attrs: { icon: "checkmark" } }),
                      _vm._v("\n\t\t\t\t\t" + _vm._s(listItem) + "\n\t\t\t\t")
                    ],
                    1
                  )
                }),
                0
              )
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }